// Mock data for Willow Ridge Golf & Country Club

export const siteInfo = {
  name: "Willow Ridge",
  tagline: "Golf & Country Club",
  phone: "519-676-8772",
  email: "info@willowridgegolf.ca",
  address: "439 Chatham St. S, PO Box 1019",
  city: "Blenheim, Ontario",
  postal: "N0P 1A0",
  bookTeeTimeUrl: "#book-tee-time",
  orderFoodUrl: "https://tableagent.com/windsor/willow-ridge-golf-country-club/",
  youtubePromo: "https://www.youtube.com/embed/Ook14DTVKis",
  mapEmbedUrl: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2935.123456789!2d-81.98!3d42.31!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDLCsDE4JzM2LjAiTiA4McKwNTgnNDguMCJX!5e0!3m2!1sen!2sca!4v1234567890",
};

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "Golf", path: "/golf", groups: [
    { title: "The Course", items: [
      { name: "Course Overview", path: "/golf#overview" },
      { name: "Valley 9", path: "/golf#valley-9" },
      { name: "Tee Times", path: "/golf#tee-times" },
      { name: "Rates", path: "/golf#rates" },
      { name: "Tournaments", path: "/golf#tournaments" },
    ]},
    { title: "Memberships & Leagues", items: [
      { name: "Memberships", path: "/memberships" },
      { name: "Leagues", path: "/leagues" },
      { name: "Junior Programs", path: "/junior-programs" },
    ]},
    { title: "Instruction", items: [
      { name: "Ladies Clinics", path: "/ladies-clinics" },
      { name: "Golf Lessons", path: "/golf-lessons" },
    ]},
  ]},
  { name: "Events", path: "/events" },
  { name: "Weddings", path: "/weddings" },
  { name: "Pub & Grill", path: "/pub-grill" },
  { name: "Contact", path: "/contact" },
];

export const heroContent = {
  title: "Experience Premier Golf",
  subtitle: "in the Heart of Chatham-Kent",
  description: "Nestled among mature trees and rolling countryside, Willow Ridge Golf & Country Club offers an exceptional golfing experience, elegant event spaces, and memorable dining.",
  ctaPrimary: "Book a Tee Time",
  ctaSecondary: "Explore the Course",
  image: "/images/dplisi8t_hero.png",
};

export const features = [
  {
    icon: "Golf",
    title: "18-Hole Championship Course",
    description: "Play our beautifully maintained 18-hole course featuring lush fairways, strategic bunkers, and pristine greens set among scenic countryside views.",
  },
  {
    icon: "Utensils",
    title: "Pub & Grill Dining",
    description: "Enjoy delicious meals and refreshing drinks at our Pub & Grill, offering a welcoming atmosphere with views of the course.",
  },
  {
    icon: "PartyPopper",
    title: "Events & Banquets",
    description: "Host your next celebration in our elegant, air-conditioned banquet hall accommodating 30 to 200 guests with full-service catering.",
  },
  {
    icon: "Heart",
    title: "Dream Weddings",
    description: "Say 'I do' surrounded by manicured lawns and countryside beauty. Our wedding packages include décor, planning, and custom menus.",
  },
];

export const courseHighlights = [
  {
    title: "Signature Holes",
    description: "Our course features several signature holes that challenge golfers of all skill levels while showcasing the natural beauty of Southwestern Ontario.",
    image: "/images/golf_hero.jpg",
  },
  {
    title: "Pristine Conditions",
    description: "Our dedicated grounds crew maintains championship-level conditions year-round, ensuring an exceptional playing surface from tee to green.",
    image: "/images/course1.jpg",
  },
  {
    title: "Pro Shop & Practice",
    description: "Visit our fully stocked pro shop and warm up on our driving range and putting green before your round.",
    image: "/images/events.jpg",
  },
];

export const golfRates = [
  { type: "Weekday 18 Holes", walking: "$45", riding: "$65" },
  { type: "Weekday 9 Holes", walking: "$28", riding: "$38" },
  { type: "Weekend 18 Holes", walking: "$55", riding: "$75" },
  { type: "Weekend 9 Holes", walking: "$33", riding: "$43" },
  { type: "Twilight (After 3pm)", walking: "$35", riding: "$50" },
  { type: "Junior (Under 16)", walking: "$25", riding: "$40" },
];

export const amenities = [
  "Driving Range",
  "Putting Green",
  "Power Carts",
  "Club Rentals",
  "Golf Lessons",
  "Pro Shop",
  "Restaurant & Pub",
  "Banquet Facilities",
  "Changing Rooms",
  "Ample Parking",
];

export const events = [
  {
    title: "Annual Chamber Golf Tournament",
    date: "June 23, 2026",
    time: "Registration 8:30 AM | Shotgun Start 9:30 AM",
    description: "Join us for the annual Chamber Golf Tournament featuring golf, cart, lunch, dinner, and gift card. A perfect networking opportunity on a beautiful course.",
    image: "/images/course1.jpg",
  },
  {
    title: "New Year's Eve Buffet Dining",
    date: "December 31, 2025",
    time: "5:00 PM - 9:00 PM",
    description: "Ring in the New Year at our club ballroom with a spectacular culinary feast, live entertainment, and a festive atmosphere for the whole family.",
    image: "/images/events.jpg",
  },
  {
    title: "Summer Twilight League",
    date: "Every Thursday, June - August",
    time: "5:00 PM Tee Off",
    description: "Join our popular summer twilight league for a fun, social round of golf followed by dinner and drinks at the Pub & Grill.",
    image: "/images/img1875.jpeg",
  },
  {
    title: "Charity Best Ball Tournament",
    date: "August 15, 2026",
    time: "9:00 AM Shotgun Start",
    description: "Support a great cause while enjoying a day on the links. This best-ball format tournament includes golf, cart, lunch, and prizes.",
    image: "/images/golf_hero.jpg",
  },
];

export const weddingPackages = [
  {
    name: "Classic",
    price: "Starting at $75/person",
    features: [
      "Elegant banquet hall setup",
      "White linen tablecloths & napkins",
      "Custom menu planning",
      "Complimentary cake cutting",
      "Microphone & podium",
      "Ample parking",
    ],
  },
  {
    name: "Premium",
    price: "Starting at $95/person",
    features: [
      "Everything in Classic",
      "Full décor rental package",
      "Wedding planning consultation",
      "TV screen for presentations",
      "Champagne toast for head table",
      "Late-night snack station",
      "Bridal suite access",
    ],
  },
  {
    name: "Ultimate",
    price: "Starting at $125/person",
    features: [
      "Everything in Premium",
      "Outdoor ceremony setup",
      "Premium bar package",
      "Live entertainment coordination",
      "Photography backdrop setup",
      "Rehearsal dinner package",
      "Complimentary overnight parking",
      "Day-of coordinator",
    ],
  },
];

export const weddingGallery = [
  "https://images.unsplash.com/photo-1523438885200-e635ba2c371e?w=600&q=80",
  "https://images.unsplash.com/photo-1721677337543-37b07e7e28b5?w=600&q=80",
  "https://images.unsplash.com/photo-1519741497674-611481863552?w=600&q=80",
  "https://images.unsplash.com/photo-1465495976277-4387d4b0b4c6?w=600&q=80",
  "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?w=600&q=80",
  "https://images.unsplash.com/photo-1519225421980-715cb0215aed?w=600&q=80",
];

export const menuCategories = [
  {
    name: "Breakfast",
    isBreakfast: true,
    description: "Served 8 AM – 11:30 AM · Available daily",
    sections: [
      {
        title: null,
        items: [
          { name: "Rising Sun Breakfast", price: "$10", description: "Two eggs any style with your choice of bacon, sausage, or ham. Served with home fries and toast." },
          { name: "The Country Boy", price: "$18", description: "Three eggs any style with bacon, sausage, and ham. Served with home fries and toast." },
          { name: "The Ridge Benny", price: "$17", description: "Two poached eggs on toasted English muffins with peameal bacon, smothered in hollandaise sauce. Served with home fries." },
          { name: "Steak & Eggs", price: "$23", description: "A 6oz AAA steak cooked to your preference. Served with two eggs any style, home fries, and toast." },
          { name: "The Short Stack", price: "$8", description: "Two fluffy pancakes with butter and syrup. Add a pancake +$2 | Add blueberry compote +$2" },
          { name: "French Toast", price: "$13", description: "Three slices of Texas-style bread dipped in a rich blend of eggs, cinnamon, cream, and vanilla, grilled to perfection and dusted with icing sugar." },
          { name: "The Scramble", price: "$13", description: "Three eggs scrambled with a three-cheese blend. Served with home fries and toast." },
          { name: "Veggie Omelette", price: "$14", description: "Three eggs filled with spinach, tomatoes, onions, mushrooms, and cheese. Served with home fries and toast." },
          { name: "Western Omelette", price: "$15", description: "A classic three-egg omelette with ham, peppers, onions, and a three-cheese blend. Served with home fries and toast." },
          { name: "Meat Lovers Skillet", price: "$21", description: "A hearty combination of three eggs, ham, bacon, and sausage, baked over crispy tater tots and topped with melted cheese. Served with toast." },
          { name: "Chicken & Waffles", price: "$21", description: "Crispy fried chicken nestled between house-made waffles, drizzled with maple bacon syrup. Served with home fries." },
          { name: "Huevos Rancheros", price: "$21", description: "A crispy corn tortilla topped with guacamole, provolone cheese, sunny-side-up eggs, chipotle drizzle, and fresh pico de gallo. Served with tater tots." },
        ],
      },
  {
    name: "Starters Shack",
    items: [
      { name: "Three Cheese Quesadilla", price: "$14", description: "Gooey melted cheese, black beans, corn, and peppers, folded into a grilled tortilla. Served with salsa & sour cream. Add chicken +$5" },
      { name: "Buffalo Chicken Bites", price: "$18", description: "Chicken and buffalo seasoning, breaded and deep fried to a golden brown. Served with ranch." },
      { name: "Pork Bao Buns (3)", price: "$18", description: "Slow braised pork belly, cilantro, green onion, hoisin aioli, pickled carrots, pickled daikon, cucumbers and a house made savoury sauce." },
      { name: "Cheddar & Bacon Beer Dip", price: "$21", description: "Rich creamy smoked cheddar, house lager, crispy bacon and chives served with warm pretzel bites." },
      { name: "Tempura Cauli Tacos (3)", price: "$21", description: "Light and crispy tempura-fried cauliflower florets served golden brown with crispy onions, pickled red onion, shredded cabbage and pineapple curry sauce." },
      { name: "Mushroom Truffle Poutine", price: "$18", description: "House made mushroom truffle gravy on top of crispy fries and authentic Quebec cheese curds." },
      { name: "Garlic Breadstick Flight", price: "$17", description: "Warm house baked garlic breadsticks served with roasted garlic aioli, classic marinara and housemade bruschetta." },
      { name: "Brisket Skins", price: "$19", description: "Crispy potato skins loaded with tender, slow-cooked BBQ brisket and melted cheese. Topped with bacon bits and fresh green onions with sour cream." },
      { name: "Asian Chicken Nachos", price: "$21", description: "Crispy fried wontons topped with seasoned chicken, green onions, pineapple, and melted cheese. Drizzled with sweet chili sauce." },
    ],
  },
  {
    name: "On The Greens",
    items: [
      { name: "Garden Salad", price: "SM $9 | LG $14", description: "A fresh mix of seasonal greens, tomatoes, cucumbers, shredded carrots, peppers, red onions, and sunflower seeds with your choice of dressing." },
      { name: "Classic Caesar", price: "SM $11 | LG $16", description: "Crisp romaine lettuce tossed in a creamy garlic dressing, topped with parmesan cheese and house-made herbed croutons. Add chicken +$5" },
      { name: "Beet Salad", price: "SM $11 | LG $16", description: "Roasted beets, red onions and spring mix, topped with creamy goat cheese, candied walnuts, and a drizzle of balsamic dressing." },
      { name: "Thai Chicken Salad", price: "$19", description: "Crisp lettuce, grilled chicken, pineapple, shredded carrots, cilantro, onions, peppers, cucumbers & crushed peanuts with a thai peanut dressing. Add shrimp +$8" },
      { name: "Taco Salad", price: "$19", description: "Romaine lettuce, diced tomatoes, onions and peppers, shredded cheese, tortilla chip crumble and seasoned ground beef. Served with salsa, sour cream & guacamole." },
    ],
  },
  {
    name: "Signature Nachos",
    items: [
      { name: "WR Nachos", price: "$19", description: "Layers of tortilla chips, tex-mex cheese, green onions, peppers and tomatoes baked to perfection. Add beef or chicken +$5" },
      { name: "Brisket Nachos", price: "$23", description: "Layers of crispy tortilla chips, house smoked brisket, black beans, corn salsa, tex-mex cheese, diced tomatoes, jalapeños and a drizzle of jalapeño lime aioli." },
      { name: "Asian Chicken Nachos", price: "$21", description: "Crispy fried wontons topped with seasoned chicken, green onions, pineapple, and melted cheese. Drizzled with sweet chili sauce." },
    ],
  },
  {
    name: "Burgers",
    description: "Our burgers are made with a premium prime rib and chuck blend. All burgers are served on a brioche bun with your choice of side: Fries, garden salad or soup of the day.",
    items: [
      { name: "The Rusty", price: "$17", description: "A classic grilled patty with lettuce, tomato, and onion — simple and satisfying." },
      { name: "Bacon Jam Burger", price: "$19", description: "Sweet jalapeño bacon jam, goat cheese, crispy fried onions, lettuce, and tomato for the perfect balance of smoky, sweet, and savory." },
      { name: "Mushroom Bacon Swiss", price: "$21", description: "Sautéed mushrooms, crispy bacon, Swiss cheese, leaf lettuce, tomato, and garlic aioli." },
      { name: "Brie & Bacon Burger", price: "$22", description: "Caramelized onions, brie, bacon, leaf lettuce and a balsamic drizzle on a brioche bun." },
      { name: "The Canadian", price: "$22", description: "Grilled patty topped with back bacon, crispy onion rings, lettuce, tomato, maple Dijon aioli, and cheddar cheese." },
      { name: "Brisket Burger", price: "$22", description: "House-smoked brisket piled high with house-made slaw, pickled onions, chef's specialty BBQ sauce, and provolone cheese." },
    ],
  },
  {
    name: "Sandwiches & Wraps",
    items: [
      { name: "Crispy Chicken", price: "$17", description: "Golden-fried chicken breast with lettuce, tomato, and garlic aioli for a crispy, juicy bite." },
      { name: "Falafel Wrap", price: "$17", description: "Baked falafel with lettuce, carrots, peppers, onions, and black beans, drizzled with garlic aioli in a soft flour tortilla." },
      { name: "Classic Reuben", price: "$19", description: "Grilled pastrami, sauerkraut, and Swiss cheese on rye bread, finished with Thousand Island dressing and a pickle spear." },
      { name: "Chicken Bacon Ranch Wrap", price: "$19", description: "Grilled or crispy chicken, bacon, lettuce, and ranch dressing wrapped in a soft flour tortilla." },
      { name: "Southwest Chicken Club", price: "$19", description: "Grilled chicken breast, bacon, lettuce, tomato, and smoky chipotle sauce. Served on a toasted ciabatta bun." },
      { name: "Nashville Chicken", price: "$19", description: "Crispy chicken breast with garlic aioli, crispy battered pickle slices, swiss cheese, house-made slaw, and hot honey sauce." },
      { name: "Korean Fried Chicken", price: "$19", description: "Golden fried chicken breast tossed in sauce with kimchi slaw, sweet & spicy gochujang aioli and pickled cucumbers." },
      { name: "Chicken Parm Sandwich", price: "$21", description: "Crispy chicken, sautéed red & green peppers, sautéed onions, mozzarella & house made marinara on a french baguette." },
      { name: "Roast Beef & Cheddar Wrap", price: "$21", description: "Warm shaved roast beef, melted cheddar, caramelized onions, and chipotle aioli grilled in a wrap." },
      { name: "Beef Dip", price: "$21", description: "Tender sliced beef, provolone cheese, peppers and crispy onions on a toasted french baguette. Served with a side of rich au jus." },
      { name: "Havana Sandwich", price: "$21", description: "Slow roasted pork, shaved ham, Swiss cheese, dill pickles, and yellow mustard on a grilled baguette." },
    ],
  },
  {
    name: "Pub Fairway",
    items: [
      { name: "Mac N Cheese", price: "$17", description: "Cavatappi noodles in a rich cheese sauce with bacon, topped with melted cheese and crispy panko crumbs. Baked and served with garlic toast. Add brisket +$5" },
      { name: "Chow Mein", price: "$17", description: "Chow mein noodles, peppers, broccoli, onions, cauliflower, celery and carrots in a house made teriyaki sauce. Add chicken +$5 | Add shrimp +$8" },
      { name: "BBQ Chicken Flatbread", price: "$18", description: "BBQ-glazed chicken, caramelized onions, mozzarella, peppers and cilantro topped with goat cheese." },
      { name: "Chicken Wings", price: "$18", description: "Crispy fried wings tossed in your choice of sauce: BBQ, Smoked Tequila & Lime, Honey Garlic, 3rd Degree, Buffalo. Dry rubs: Salt & Pepper, Cajun, Lemon Pepper, Jerk, Spicy Dill Pickle, Garlic Parmesan." },
      { name: "Fish & Chips", price: "$19", description: "Hand-battered basa filet, deep-fried. Served with french fries, house-made slaw, tartar sauce, and a lemon wedge." },
      { name: "Fish Tacos", price: "$19", description: "Two grilled soft-shell tortillas filled with crispy basa, house-made slaw, lettuce, pineapple salsa, and lime aioli. Served with your choice of side." },
      { name: "Broasted Chicken", price: "$19", description: "Three pieces of golden-fried chicken served with french fries and house-made slaw." },
      { name: "Tex-Mex Bowl", price: "$21", description: "Crispy golden tater tots topped with house smoked brisket, melted mixed cheese, fresh lettuce, diced tomatoes, sliced green onions, jalapeños. Served with corn salsa and sour cream." },
      { name: "House Smoked ½ Chicken", price: "$21", description: "Juicy, house-smoked half chicken served with house-made slaw and french fries." },
      { name: "House-Smoked Ribs", price: "Half $21 | Full $27", description: "House-smoked ribs served with french fries and house-made slaw." },
      { name: "Mushroom Gnocchi", price: "$24", description: "Pan-seared gnocchi tossed with wild mushrooms, baby spinach, and crispy bacon in a rich blush tomato cream sauce. Finished with shaved parmesan and truffle oil." },
      { name: "Pecan Crusted Salmon", price: "$28", description: "Pecan crusted salmon with a maple garlic glaze served with mashed potato and seasonal vegetable." },
      { name: "AAA New York Strip", price: "6oz $23 | 10oz $29", description: "Served with seasonal vegetables and your choice of daily potato or french fries. Add shrimp +$8 | Add mushroom truffle gravy +$3" },
    ],
  },
  {
    name: "Sides & Specials",
    items: [
      { name: "Soup of the Day", price: "$6", description: "Ask your server for today's fresh selection." },
      { name: "French Fries", price: "$7", description: "Classic golden fries." },
      { name: "Onion Rings", price: "$8", description: "Crispy battered onion rings. Upgrade from fries +$3" },
      { name: "Curly Fries", price: "$8", description: "Seasoned curly fries. Upgrade from fries +$3" },
      { name: "Tater Tots", price: "$8", description: "Golden crispy tater tots. Upgrade from fries +$3" },
      { name: "Sweet Potato Fries", price: "$8", description: "Lightly seasoned sweet potato fries. Upgrade from fries +$3" },
      { name: "Smokehouse Platter (Serves 4)", price: "$95", description: "2lbs brisket, ½ smoked chicken, full rack of ribs, mac n cheese, coleslaw, french fries & fried pickle chips. Available Sunday to Thursday. Ask about our Smokehouse Platter Challenge!" },
    ],
  },
      {
        title: "Just the Sandwedge",
        items: [
          { name: "Bacon or Sausage N' Egger", price: "$7", description: "Two fried eggs with bacon or a sausage patty and cheddar on a toasted English muffin." },
          { name: "Toasted Western", price: "$8", description: "Two scrambled eggs with ham, peppers, onions, and cheese on your choice of toast." },
          { name: "Classic BLT", price: "$8", description: "Crispy bacon, fresh lettuce, tomato, and mayo on Texas toast. Upgrade to sourdough +$1" },
          { name: "Breakfast Wrap", price: "$10", description: "Two scrambled eggs with bacon, onions, peppers, and cheese in a warm flour tortilla." },
          { name: "Ridge Wrap", price: "$13", description: "A hearty wrap filled with two scrambled eggs, bacon, sausage, ham, tater tots, and cheese, finished on the grill." },
        ],
      },
      {
        title: "From the Bunker",
        isAddons: true,
        items: [
          { name: "Add an Egg", price: "$3", description: "" },
          { name: "Home Fries", price: "$4", description: "" },
          { name: "Tater Tots", price: "$4", description: "" },
          { name: "Bacon, Sausage, or Ham", price: "$5", description: "" },
          { name: "Peameal Bacon", price: "$6", description: "" },
          { name: "Toast (white, brown, or rye)", price: "$3", description: "" },
          { name: "English Muffin", price: "$3", description: "" },
        ],
      },
      {
        title: "Drinks",
        isAddons: true,
        items: [
          { name: "Coffee or Tea", price: "$3", description: "" },
          { name: "Orange Juice", price: "$3", description: "" },
          { name: "Apple Juice", price: "$3", description: "" },
          { name: "Milk", price: "$4", description: "" },
          { name: "Fountain Pop", price: "$3", description: "" },
        ],
      },
      {
        title: "Brunch Cocktails",
        isAddons: true,
        items: [
          { name: "Classic Mimosa", price: "$7", description: "" },
          { name: "Classic Caesar", price: "$8", description: "" },
          { name: "Spanish Coffee", price: "$8", description: "" },
        ],
      },
    ],
  },
  {
    name: "Weekly Specials",
    isSpecials: true,
    items: [
      { name: "Tuesday", price: "", description: "$5 Triple Bogey Coolers | $5 Pints of WR Lager | $5 Off any Nachos" },
      { name: "Wednesday", price: "", description: "$6 Seasons Wine (6oz) | $6 Pints of Bud Light | $12/lb Wing Wednesday" },
      { name: "Thursday", price: "", description: "$6 Pints or Cans of Sons of Kent | $10 Mini Pitchers of Sons of Kent | $5 Off any of our Burgers! (Excluding the Turn Burger)" },
      { name: "Friday", price: "", description: "$28 6 Piece Perch Dinner | $19 Perch on a Bun" },
    ],
  },
  {
    name: "Turn Window",
    items: [
      { name: "Soup of the Day & Sandwich", price: "$10", description: "Quick and satisfying combo to keep you fueled on the course." },
      { name: "Turn Burger & Fries", price: "$11", description: "A hearty burger with fries — perfect for the turn." },
      { name: "Hot Dog & Fries", price: "$10", description: "Classic grilled hot dog served with fries." },
      { name: "Sausage & Fries", price: "$11", description: "Grilled sausage served with a side of fries." },
    ],
  },
];

export const staff = [
  {
    name: "Chris Hill",
    title: "CPGA Golf Professional",
    department: "Golf & Golf Events",
    email: "chill@willowridgegolf.ca",
    phone: "5196768772,,6",
    phoneDisplay: "(519) 676-8772 ext. 6",
    description: "As our CPGA Golf Professional, Chris oversees all golf operations including tee times, lessons, tournaments, and golf events. His expertise and passion for the game ensure every golfer enjoys a first-class experience at Willow Ridge.",
    image: "/images/chris.jpg",
  },
  {
    name: "Shannon Thyssen",
    title: "Food & Beverage Manager",
    department: "Pub, Weddings, Events & Catering",
    email: "sthyssen@willowridgegolf.ca",
    phone: "5196768772,,4",
    phoneDisplay: "(519) 676-8772 ext. 4",
    description: "Shannon manages all food & beverage operations, from the Pub & Grill to wedding receptions, banquets, and special event catering. Her attention to detail and warm hospitality make every occasion at Willow Ridge truly memorable.",
    image: "/images/shannon.jpg",
  },
  {
    name: "Phong Inthachack",
    title: "Head Chef",
    department: "Kitchen & Culinary",
    email: "",
    phone: "5196768772,,3",
    phoneDisplay: "(519) 676-8772 ext. 3",
    description: "Phong leads our kitchen with creativity and precision, crafting the diverse menu that makes the Pub & Grill a destination in its own right. From pub classics to chef specials and custom catering menus, his culinary expertise elevates every dish.",
    image: "/images/phong.jpg",
  },
  {
    name: "Scott Davis",
    title: "Pro Shop",
    department: "Pro Shop & Retail",
    email: "",
    phone: "5196768772,,1",
    phoneDisplay: "(519) 676-8772 ext. 1",
    description: "Scott keeps our Pro Shop stocked with the latest gear, apparel, and accessories. Whether you need advice on equipment, a last-minute gift, or help with rentals, Scott is your go-to for all things golf.",
    image: "/images/scott.jpg",
  },
];

export const testimonials = [
  {
    name: "Sarah & Michael D.",
    event: "Wedding Reception",
    text: "Our wedding at Willow Ridge was absolutely magical. The countryside backdrop, the elegant ballroom, and the incredible food made our special day truly unforgettable.",
    rating: 5,
  },
  {
    name: "Tom R.",
    event: "Golf Member",
    text: "Best kept secret in Chatham-Kent. The course is always in fantastic condition and the staff makes you feel like family. Love the twilight league!",
    rating: 5,
  },
  {
    name: "Jennifer L.",
    event: "Corporate Event",
    text: "We hosted our annual company golf tournament here and it exceeded all expectations. The team was incredibly organized and accommodating.",
    rating: 5,
  },
];
